import { CategoryType } from 'src/ConsentManagement/Models/TealiumCategoryModel';
import { Tealium } from '../Tealium/TealiumTypes'

export class CategoryMapper {
  public static map(options: number[]): Tealium.Compliance.SelectedCategories {
    const catagories = new Tealium.Compliance.SelectedCategories();
    catagories[CategoryType.Misc] = Tealium.Compliance.State.On;
    if (!options.includes(1)) return catagories;

    if (options.includes(2) && options.includes(3) && options.includes(4) && options.includes(7)) {
      catagories[CategoryType.Affiliates] = Tealium.Compliance.State.On;
      catagories[CategoryType.DisplayAd] = Tealium.Compliance.State.On;
      catagories[CategoryType.Search] = Tealium.Compliance.State.On;
    }

    if (options.includes(5) && options.includes(6)) {
      catagories[CategoryType.Personalization] = Tealium.Compliance.State.On;
    }

    if (options.includes(8)) {
      catagories[CategoryType.Analytics] = Tealium.Compliance.State.On;
    }

    if (options.includes(9)) {
      catagories[CategoryType.Mobile] = Tealium.Compliance.State.On;
    }

    if (options.includes(10)) {
      catagories[CategoryType.Engagement] = Tealium.Compliance.State.On;
    }

    if (options.includes(1000)) {
      catagories[CategoryType.Social] = Tealium.Compliance.State.On;
    }

    return catagories;
  }
}
